<button
  class="button is-small"
  [class.is-active]="isActive"
  [attr.data-theme]="theme()"
  [cdkMenuTriggerFor]="menu"
  (cdkMenuOpened)="isActive = true"
  (cdkMenuClosed)="isActive = false">
  <i
    style="font-weight: 400; font-size: 24px"
    class="icon icon-help"></i>
</button>

<ng-template #menu>
  <div
    cdkMenu
    class="action-menu">
    <a
      cdkMenuItem
      href="mailto:support@crisis24.com"
      class="action-menu-item">
      {{ 'MANAGEMENT.HELP-MENU.CONTACT-US' | translate }}
    </a>
    <div
      cdkMenuItem
      class="action-menu-item"
      (click)="goToZendeskKnowledgeBase()">
      {{ 'MANAGEMENT.HELP-MENU.KNOWLEDGE-BASE' | translate }}
    </div>
    <div
      cdkMenuItem
      class="action-menu-item"
      (click)="goToLitmosTraining()">
      {{ 'MANAGEMENT.HELP-MENU.TRAINING' | translate }}
    </div>
  </div>
</ng-template>
